<template>
	<div class="development">
		<v-row>
            <v-col>
                <v-card>
                    <v-tabs grow>
                        <v-tab to="/development/sales">Salg</v-tab>
                        <v-tab to="/development/efficiency">Effektivitet</v-tab>
                    </v-tabs>
                </v-card>
            </v-col>
			<v-col>
				<v-select solo :items="teams" v-model="$store.state.main.team" label="Team" />
			</v-col>
			<v-col>
				<v-autocomplete
                    solo
					:items="$store.getters['development/userSelect']"
					v-model="$store.state.development.user"
					label="Agentur"
				></v-autocomplete>
			</v-col>
			<v-col>
				<v-autocomplete
                    solo
					:items="$store.getters['development/campaignSelect']"
					v-model="$store.state.development.campaign"
					label="Kampagne"
                    :disabled="$store.state.development.tab === 'efficiency'"
				></v-autocomplete>
			</v-col>
			<v-col class="d-flex align-baseline justify-space-between">
				<v-select
                    solo
					:items="presets"
					v-model="$store.state.development.period"
					label="Periode"
				/>
			</v-col>
		</v-row>
        <v-row no-gutters align="baseline" style="margin-top: -15px">
            <v-col>
                <v-radio-group style="margin-top: 0" row v-model="$store.state.development.granularity">
                    <v-radio label="Ugedage" value="day" />
                    <v-radio label="Dage" value="date" />
                    <v-radio label="Uger" value="week" />
                    <v-radio label="Måneder" value="month" />
                </v-radio-group>
            </v-col>
            <v-col class="d-flex justify-space-between">
                <v-checkbox v-model="$store.state.development.excludeWinback" label="Ekskl. retention" :disabled="$store.state.development.tab === 'efficiency'"/>
                <v-checkbox v-model="$store.state.development.excludeInactive" label="Ekskl. inaktive" :disabled="$store.state.development.tab === 'efficiency'"/>
            </v-col>
            <v-col class="graph-type-column" :disabled="$store.state.development.tab === 'efficiency'">
                <v-radio-group style="margin-top: 0" row v-model="$store.state.development.graphType" :disabled="$store.state.development.tab === 'efficiency'">
                    <v-radio label="Faktisk" value="actual" />
                    <v-radio label="Akkumuleret" value="accumulated" />
                </v-radio-group>
            </v-col>
        </v-row>
        <!-- <v-divider class="mx-2" />
        <v-row class="collapsed-inputs" v-if="$store.state.development.tab !== 'efficiency'" align="center" justify="end">
            <v-col cols="3" class="d-flex justify-end">
                <v-switch label="Filtrer på opstartsdato" v-model="$store.state.development.filterStartDate" />
            </v-col>
            <v-col cols="4">
                <range-picker storeName="development" rangeName="startDateRange" :presets="presets" :disabled="!$store.state.development.filterStartDate" />
            </v-col>
        </v-row> -->
        <router-view />
	</div>
</template>

<script>
// import RangePicker from "@/components/rangePicker"

export default {
	components: {
        // RangePicker
    },
    computed: {
        period () {
            return this.$store.state.development.period
        },
        granularity () {
            return this.$store.state.development.granularity
        },
        presets () {
            return this.$store.state.development.presets[this.granularity]
        },
        teams () {
            return this.$route.name === 'efficiency' ? this.$store.state.main.teams.slice(1) : this.$store.state.main.teams
        },
		userSelect() {
			return this.$store.getters["development/userSelect"];
		}
    },
    created () {
        if (!this.period) this.$store.commit("development/setRange", 'Seneste 4 uger');
    },
    watch: {
        granularity: function () {
            if (!this.presets.includes(this.period)) this.$store.state.development.period = this.presets[0];
        },
        teams: function () {
            if (!this.teams.includes(this.$store.state.main.team)) this.$store.state.main.team = this.teams[0]
        },
        userSelect() {
            if (!this.userSelect.includes(this.$store.state.development.user)) this.$store.state.development.user = 'Alle agenturer'
        }
    }
}
</script>

<style lang="scss">
.development {
    .graph-type-column {
        .v-input--radio-group__input {
            justify-content: flex-end;
        }
    }
}
</style>